import React from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import TablerLayout from "../components/layout/TablerLayout";
import FullWidthButton from "../components/buttons/FullWidthButton";

const Admin = () => {
	const navigate = useStepNavigate();

	const handleBack = () => {
		navigate('/Home');
	};

	return (
		<TablerLayout title="Admin oldal">
			<div className="row justify-content-center">
				<div className="col-md-10">
					<div className="card-body">
						<div className="row g-4 justify-content-center">
							<div className="col-md-6 text-center mb-4">
								<FullWidthButton 
									onClick={() => navigate('/Admin/ModellKezelo')}
									height="100px"
									plusClass="fs-4 btn-success d-flex align-items-center justify-content-center gap-2 border-0"
									style={{ color: "white", backgroundColor: "orange" }}
								>
									Modellek kezelése
								</FullWidthButton>
							</div>
							<div className="col-md-6 text-center mb-4">
								<FullWidthButton 
									onClick={() => navigate('/RendelesekKezelese')}
									height="100px"
									plusClass="fs-4"
								>
									Rendelések kezelése
								</FullWidthButton>
							</div>
							
						</div>
					</div>
					<div className="card-footer d-flex justify-content-center">
						<button 
							className="btn btn-secondary px-4"
							onClick={handleBack}
						>
							Vissza a főoldalra
						</button>
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default Admin;